import { BaseViewStore } from 'core/stores';

class NikoFacilityOrderNewFlowInventoryCalculationVerificationModalStore extends BaseViewStore {
	constructor(rootStore, componentsProps) {
		super(rootStore);
		this.rootStore = rootStore;
		this.facilityInventoryCalculationItem = componentsProps.modalParams.data.facilityInventoryCalculationItem;
	}
}

export default NikoFacilityOrderNewFlowInventoryCalculationVerificationModalStore;